import { render, staticRenderFns } from "./headerLogin.vue?vue&type=template&id=5f21e3f4"
import script from "./headerLogin.vue?vue&type=script&lang=js"
export * from "./headerLogin.vue?vue&type=script&lang=js"
import style0 from "./headerLogin.vue?vue&type=style&index=0&id=5f21e3f4&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports